<app-zen-dialog-wrapper [data]="data" [hideButton]="true">
  @if (loading) {
    <app-zen-loader></app-zen-loader>
  }
  <app-zen-tac-texts (tacId)="onTacId($event)"></app-zen-tac-texts>
  <div mat-dialog-actions class="center mt-4">
    <button mat-raised-button color="accent"
    (click)="onSubmit()" [disabled]="loading">Accept & Continue</button>
  </div>
</app-zen-dialog-wrapper>
